import {
  LayoutDashboard,
  Users,
  Blocks,
  ScrollText,
  Handshake,
  Cog,
  ClipboardList
} from 'lucide-react';
import { AuthConstant, MastersId, MastermenuTitleName, ParentmenuTitle } from './constant.js';

export const MenuListNew = [
  {
    title: 'Dashboard',
    content: [
      {
        title: 'Dashboard Light',
        to: '/dashboard',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        title: 'Dashboard Dark',
        to: '/dashboard-dark',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        title: 'Patient',
        to: '/patient-list',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        title: 'Doctor',
        to: '/doctor-list',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      }
    ]
  },
  {
    title: 'Masters',
    content: [
      {
        id: 1,
        title: 'Users',
        to: '/users',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        id: 2,
        title: 'City',
        to: '/city',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        id: 13,
        title: 'Area',
        to: '/area',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        id: 3,
        title: 'Organization Type',
        to: '/orginisation-type',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        id: 4,
        title: 'Speciality',
        to: '/speciality',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        id: 5,
        title: 'Designation',
        to: '/designation',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        id: 6,
        title: 'Module',
        to: '/modules',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        id: 7,
        title: 'Call Type',
        to: '/call-type',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        id: 8,
        title: 'Demo Status',
        to: '/demo-status',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        id: 9,
        title: 'User Non User',
        to: '/user-non-user',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        id: 12,
        title: 'Software Name',
        to: '/softwares',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      }
    ]
  },
  {
    title: 'Clients',
    to: '/clients',
    addPermission: true,
    editPermission: true,
    deletePermission: true,
    viewPermission: true,
    content: [
      {
        title: 'Clients',
        to: '/clients',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        title: 'Add Client',
        to: '/add-client',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      }
    ]
  },

  {
    title: 'Installation Details',
    to: '/installation-details',
    addPermission: true,
    editPermission: true,
    deletePermission: true,
    viewPermission: true,
    content: [
      {
        title: 'Installation Details',
        to: '/installation-details',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        title: 'Add Installation',
        to: '/add-installation',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      }
    ]
  },
  {
    title: 'AMC List',
    to: '/amc-list',
    addPermission: true,
    editPermission: true,
    deletePermission: true,
    viewPermission: true
  },
  {
    title: 'DCR',
    content: [
      {
        title: 'DCR List',
        to: '/dcr-list',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        id: 18,
        title: 'DCR Clients',
        to: '/dcr-clients',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        id: 19,
        title: 'Area',
        to: '/dcr-area',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        id: 20,
        title: 'City',
        to: '/dcr-city',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      }
    ]
  },
  {
    title: 'Issues',
    content: [
      {
        title: 'Issues',
        to: '/issues',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      },
      {
        title: 'Products',
        to: '/products',
        addPermission: true,
        editPermission: true,
        deletePermission: true,
        viewPermission: true
      }
    ]
  }
];

export const MenuListFlat = [
  {
    menuID: 1,
    menuName: 'Masters',
    subMenus: [
      {
        menuItemID: 1001,
        menuItemName: 'Users',
        routingKey: '/users',
        sortOrder: 1001.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      },
      {
        menuItemID: 1002,
        menuItemName: 'City',
        routingKey: '/city',
        sortOrder: 1002.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      },
      {
        menuItemID: 1003,
        menuItemName: 'Area',
        routingKey: '/area',
        sortOrder: 1003.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      },
      {
        menuItemID: 1004,
        menuItemName: 'Org Type',
        routingKey: '/orginisation-type',
        sortOrder: 1004.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      },
      {
        menuItemID: 1005,
        menuItemName: 'Speciality',
        routingKey: '/speciality',
        sortOrder: 1005.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      },
      {
        menuItemID: 1006,
        menuItemName: 'Designation',
        routingKey: '/designation',
        sortOrder: 1006.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      },
      {
        menuItemID: 1007,
        menuItemName: 'Modules',
        routingKey: '/modules',
        sortOrder: 1007.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      },
      {
        menuItemID: 1008,
        menuItemName: 'Call Type',
        routingKey: '/call-type',
        sortOrder: 1008.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      },
      {
        menuItemID: 1009,
        menuItemName: 'Demo Status',
        routingKey: '/demo-status',
        sortOrder: 1009.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      },
      {
        menuItemID: 1010,
        menuItemName: 'User/Non User',
        routingKey: '/user-non-user',
        sortOrder: 1010.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      },
      {
        menuItemID: 1011,
        menuItemName: 'Softwares',
        routingKey: '/softwares',
        sortOrder: 1011.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      }
    ]
  },
  {
    menuID: 2,
    menuName: 'Clients',
    subMenus: [
      {
        menuItemID: 2001,
        menuItemName: 'Clients',
        routingKey: '/clients',
        sortOrder: 2001.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      }
    ]
  },
  {
    menuID: 3,
    menuName: 'Installation Details',
    subMenus: [
      {
        menuItemID: 3001,
        menuItemName: 'Installation Details',
        routingKey: '/installation-details',
        sortOrder: 3001.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      }
    ]
  },
  {
    menuID: 4,
    menuName: 'Amc List',
    subMenus: [
      {
        menuItemID: 4001,
        menuItemName: 'Amc List',
        routingKey: '/amc-list',
        sortOrder: 4001.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      }
    ]
  },
  {
    menuID: 5,
    menuName: 'DCR',
    subMenus: [
      {
        menuItemID: 5001,
        menuItemName: 'DCR List',
        routingKey: '/dcr-list',
        sortOrder: 5001.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      },
      {
        menuItemID: 5002,
        menuItemName: 'DCR Clients',
        routingKey: '/dcr-clients',
        sortOrder: 5002.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      },
      {
        menuItemID: 5003,
        menuItemName: 'DCR City',
        routingKey: '/dcr-city',
        sortOrder: 5003.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      },
      {
        menuItemID: 5004,
        menuItemName: 'DCR Area',
        routingKey: '/dcr-area',
        sortOrder: 5004.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      }
    ]
  },
  {
    menuID: 6,
    menuName: 'Issue Tracker',
    subMenus: [
      {
        menuItemID: 6001,
        menuItemName: 'Issues',
        routingKey: '/issues',
        sortOrder: 6001.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      },
      {
        menuItemID: 6002,
        menuItemName: 'Products',
        routingKey: '/products',
        sortOrder: 6002.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      }
    ]
  },
  {
    menuID: 7,
    menuName: 'Roles & Permissions',
    subMenus: [
      {
        menuItemID: 7001,
        menuItemName: 'Users Rights',
        routingKey: '/users-rights',
        sortOrder: 7001.0,
        hasListPermission: true,
        hasAddPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        IsAssigned: true
      }
    ]
  }
];
